import React, {useContext} from 'react';
import {TypicalMessage, TypicalMessageProps} from './TypicalMessage';
import {LocaleContext} from '../../../../../src/contexts/LocaleContext';
import {toDate} from './index';

export function OrderTaskPayloadChangeAtChanged(props: TypicalMessageProps) {
    useContext(LocaleContext);

    const details = props.model.message_details;
    if (details['@type'] !== 'order-task.change-status.change-at-changed' || !('target' in details)) {
        return <TypicalMessage model={props.model} options={props.options}/>;
    }

    return <TypicalMessage
            model={props.model}
            options={props.options}
            replace={{
                was: toDate(details.was),
                became: toDate(details.became),
            }}
            choice={details.target === 'order' ? 1 : 2}
            optionsKey={details.target === 'order' ? 'status' : 'productStatuses'}
    />;
}
